import { ExportListParams, list } from "@/getinfo-api/exports";
import { importExportApi } from "@/getinfo-api";

export class ImportExport {
  static async getExportList(params: ExportListParams) {
    const { data } = await list(params);

    return data;
  }

  static async getExportTypes() {
    const { data } = await importExportApi.Export.getExportTypes();
    return data;
  }

  static async getImportTypes() {
    const { data } = await importExportApi.Import.getImportTypes();
    return data;
  }

  static async getExportById(id: string) {
    const { data } = await importExportApi.Export.getExport(id);

    return data;
  }
}
